/* eslint-disable react-hooks/exhaustive-deps */
// wijmo

import React, { useContext, useEffect, useState } from "react"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"
import { Button, Col, Container, Row } from "react-bootstrap"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import { TModalTypes, ModalOuter } from "../../../components/Modal/ModalOuter"
import Spinner from "../../../components/Spinner"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { showInfoToast } from "../../../components/CustomToast"
import { AppDispatch } from "../../.."
import { useDispatch } from "react-redux"
import TextInput from "../../../components/InputWrapper/TextInput"
import LabelFormRow from "../../../components/LabelFormRow"
import dayjs from "dayjs"
import KyuyuryoService from "../../../service/truckcontrol/kyuyuryo/kyuyuryoService"
import { setAlerts } from "../../../globalStore/alertStore"
import { FunctionContext } from "../../../components/Context"
import { TApiResponse } from "../../../service/TApiResponse"
import { TKyuyuryoPutReq } from "../../../service/truckcontrol/kyuyuryo/TKyuyuryo"

/**
 * 給油量編集モーダル（手入力）
 * @param {*} props
 * @return {*} reactNode
 */
const KyuyuryoEditModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title: string
    footer?: React.ReactNode
    乗務員ID: number
    年月: string
  }
> = (props) => {
  //#region [method]

  /**
   * 更新アイテム生成
   * @returns
   */
  const createPutKyuyuryo = (): TKyuyuryoPutReq => {
    return {
      給油年月: 年月,
      中日本給油_給油量合計ID: 中日本ID,
      中日本給油_合計数量: 中日本,
      中日本給油_更新日時: 中日本更新日時,
      飯田運輸給油_給油量合計ID: 飯田ID,
      飯田運輸給油_合計数量: 飯田,
      飯田運輸給油_更新日時: 飯田更新日時,
      予備カード給油_給油量合計ID: 予備カードID,
      予備カード給油_合計数量: 予備カード,
      予備カード給油_更新日時: 予備カード更新日時,
      現金給油_給油量合計ID: 現金ID,
      現金給油_合計数量: 現金,
      現金給油_更新日時: 現金更新日時,
    }
  }

  const beforeSubmit = () => {
    //   TODO: バリデーションチェック
    setIsConfirmModalShow(true)
  }

  const submit = async () => {
    try {
      // error回避
      if (予備カード == null || 中日本 == null || 飯田 == null || 現金 == null)
        return

      const service = new KyuyuryoService()
      let res: TApiResponse<boolean>

      res = await service.put(props.乗務員ID, createPutKyuyuryo())

      disPatch(setAlerts(res))
      if (res) {
        props.setIsShow(false)
        showInfoToast(`給油量の更新が完了しました。`)
      }
      pageSearch()
    } catch (error) {
      setAlertSource(error)
    } finally {
    }
    setIsConfirmModalShow(false)
  }

  const getData = async (
    乗務員ID: number,
    年月: string,
    signal: AbortSignal
  ) => {
    const service = new KyuyuryoService()

    // 固定Grid
    try {
      const res = await service.getList({ 乗務員ID: 乗務員ID, 年月: 年月 })
      if (res.data && 0 < res.data.length) {
        const d = res.data[0]
        // 検索結果をstateにセット
        set乗務員(d.社員氏名)

        set予備カード(d.予備カード給油_合計数量)
        set中日本(d.中日本給油_合計数量)
        set飯田(d.飯田運輸給油_合計数量)
        set現金(d.現金給油_合計数量)

        set予備カード更新日時(d.予備カード給油_更新日時)
        set中日本更新日時(d.中日本給油_更新日時)
        set飯田更新日時(d.飯田運輸給油_更新日時)
        set現金更新日時(d.現金給油_更新日時)

        set予備カードID(d.予備カード給油_給油量合計ID)
        set中日本ID(d.中日本給油_給油量合計ID)
        set飯田ID(d.飯田運輸給油_給油量合計ID)
        set現金ID(d.現金給油_給油量合計ID)
      }
    } catch (error) {
      setAlertSource(error)
    } finally {
    }
  }

  //#endregion

  //#region [state]
  // 検索用
  const pageSearch = useContext(FunctionContext)

  const [乗務員, set乗務員] = useState<string>()
  const [年月, set年月] = useState<string>(props.年月)

  // 編集項目
  const [予備カード, set予備カード] = useState<number>(0)
  const [中日本, set中日本] = useState<number>(0)
  const [飯田, set飯田] = useState<number>(0)
  const [現金, set現金] = useState<number>(0)
  const [予備カード更新日時, set予備カード更新日時] = useState<string>("")
  const [中日本更新日時, set中日本更新日時] = useState<string>("")
  const [飯田更新日時, set飯田更新日時] = useState<string>("")
  const [現金更新日時, set現金更新日時] = useState<string>("")
  const [予備カードID, set予備カードID] = useState<number>()
  const [中日本ID, set中日本ID] = useState<number>()
  const [飯田ID, set飯田ID] = useState<number>()
  const [現金ID, set現金ID] = useState<number>()

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  const disPatch: AppDispatch = useDispatch()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // init
  const [initialDataSetFlag, setInitialDataSetFlag] = useState(false)

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  //#endregion

  //#region [effect]

  useEffect(() => {
    setAlertSource(undefined)

    if (props.isShow) {
      set年月(props.年月)
      setInitialDataSetFlag(true)
    } else {
      set乗務員("")
      set年月("")
      set予備カード(0)
      set中日本(0)
      set飯田(0)
      set現金(0)

      set予備カードID(undefined)
      set中日本ID(undefined)
      set飯田ID(undefined)
      set現金ID(undefined)

      setIsSpinnerShow(true)
    }
  }, [props.isShow])

  useEffect(() => {
    if (initialDataSetFlag) {
      const abortController = new AbortController()
      getData(props.乗務員ID, props.年月, abortController.signal).finally(
        () => {
          setInitialDataSetFlag(false)
          setIsSpinnerShow(false)
        }
      )
    } else {
      setIsSpinnerShow(false)
    }
  }, [initialDataSetFlag])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "給油量手入力"}
      setIsShow={props.setIsShow}
      size={"sm"}
      footer={
        <>
          <Button
            type="submit"
            variant="waiting"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              beforeSubmit()
            }}>
            登録
          </Button>
        </>
      }>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid className="register-form">
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <div>
                <LabelFormRow
                  label="乗務員"
                  labelWidth={5}
                  formWidth={2}
                  Width={7}>
                  <TextInput
                    style={{ width: "10rem" }}
                    id="乗務員"
                    name="乗務員"
                    value={乗務員}
                    isReadOnly={true}
                    setValue={set乗務員}
                  />
                </LabelFormRow>
                <LabelFormRow
                  label="年月"
                  labelWidth={5}
                  formWidth={2}
                  Width={7}>
                  <TextInput
                    style={{ width: "10rem" }}
                    id="年月"
                    name="年月"
                    value={dayjs(年月).format("YYYY/MM")}
                    isReadOnly={true}
                    setValue={set年月}
                  />
                </LabelFormRow>
              </div>
            </Col>
          </Row>
          <br></br>
          <Row>
            <Col>
              <div>
                <LabelFormRow
                  label="予備カード"
                  labelWidth={5}
                  formWidth={6}
                  Width={10}>
                  <wjrInput.InputNumber
                    style={{ width: "10rem" }}
                    id="予備カード"
                    name="予備カード"
                    format={"G2"}
                    isRequired={true}
                    value={予備カード}
                    valueChanged={(c: wjcInput.InputNumber, e: any) => {
                      c.value != null
                        ? set予備カード(c.value)
                        : set予備カード(0)
                    }}
                  />
                </LabelFormRow>
                <LabelFormRow
                  label="中日本"
                  labelWidth={5}
                  formWidth={6}
                  Width={10}>
                  <wjrInput.InputNumber
                    style={{ width: "10rem" }}
                    id="中日本"
                    name="中日本"
                    format={"G2"}
                    isRequired={true}
                    value={中日本}
                    valueChanged={(c: wjcInput.InputNumber, e: any) => {
                      c.value != null ? set中日本(c.value) : set中日本(0)
                    }}
                  />
                </LabelFormRow>
                <LabelFormRow
                  label="飯田"
                  labelWidth={5}
                  formWidth={6}
                  Width={10}>
                  <wjrInput.InputNumber
                    style={{ width: "10rem" }}
                    id="飯田"
                    name="飯田"
                    format={"G2"}
                    isRequired={true}
                    value={飯田}
                    valueChanged={(c: wjcInput.InputNumber, e: any) => {
                      c.value != null ? set飯田(c.value) : set飯田(0)
                    }}
                  />
                </LabelFormRow>
                <LabelFormRow
                  label="現金"
                  labelWidth={5}
                  formWidth={6}
                  Width={10}>
                  <wjrInput.InputNumber
                    style={{ width: "10rem" }}
                    id="現金"
                    name="現金"
                    format={"G2"}
                    isRequired={true}
                    value={現金}
                    valueChanged={(c: wjcInput.InputNumber, e: any) => {
                      c.value != null ? set現金(c.value) : set現金(0)
                    }}
                  />
                </LabelFormRow>
              </div>
            </Col>
          </Row>
        </form>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </ModalOuter>
  )
}

export default KyuyuryoEditModal
